import styled from 'styled-components'

export const Fill = styled.div`
    box-sizing: border-box;
    cursor: grab;
    height: 100%;
    min-width: 0;
    width: 100%;

    &:active {
        cursor: grabbing;
    }
`
